/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function PanelLeftClose({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#PanelLeftClose_svg__a)"><path fill="currentColor" d="M13.444 15.1c1.148 0 2.156-.875 2.156-2.045V2.945C15.6 1.775 14.592.9 13.444.9H2.555C1.407.9.4 1.775.4 2.945v10.11c0 .557.239 1.083.647 1.462.407.378.95.583 1.508.583h10.889ZM2.555 13.9c-.267 0-.515-.1-.691-.263a.795.795 0 0 1-.264-.582V2.945c0-.426.385-.845.955-.845h1.636v11.8H2.555Zm2.836 0V2.1h8.053c.57 0 .956.42.956.845v10.11c0 .425-.386.845-.956.845H5.39Z" /><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M9.497 9.697 7.8 8l1.697-1.697M7.8 8h4.243" /></g><defs><clipPath id="PanelLeftClose_svg__a"><path fill="#fff" d="M0 16h16V0H0z" /></clipPath></defs></svg>;
}
;